export enum TabsEventType {
	UPDATE_TABS = 'updateTabs',
	GET_ACTIVE_TAB = 'getActiveTab',
	UPDATE_SMARTTAG_DATA = 'updateSmartTagsData',
};

export class BroadcastTabsEventMetadata {
	reloadData?: boolean;

	constructor() {
		this.reloadData = false;
	}
}